import { forwardRef } from 'react';
import { Typography, Box } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

interface WeeksTabProps {
  weeksList?: any;
  week?: any;
  setWeek?: (e: any) => void;
  weekRange?: any;
  setWeekRange?: (e: any) => void;
}

const WeeksTab = forwardRef((props: WeeksTabProps, _ref) => {
  return (
    <Box display="flex" justifyContent="center" mb="6px" width="100%">
      <Box
        onClick={() => {
          props?.setWeekRange({
            from: props?.weekRange.from - 1,
            to: props?.weekRange.to - 1
          });
        }}
        className={
          props?.weekRange.from !== 0
            ? 'weeks-tab-prev-btn'
            : 'weeks-tab-prev-btn weeks-tab-prev-btn-disabled'
        }
      >
        <KeyboardArrowLeftIcon />
      </Box>
      <Box display="flex" justifyContent="center" width="calc(100% - 80px)">
        {props?.weeksList.map((wk: any, i: number) => {
          if (i+3 >= props?.weekRange.from && i+3 <= props?.weekRange.to) {
            return (
              <Box
                key={i}
                onClick={() => props?.setWeek(wk)}
                className={
                  props?.week?.weekNum === wk.weekNum
                    ? 'weeks-tab weeks-tab-selected'
                    : 'weeks-tab'
                }
              >
                <Typography fontWeight={600} textAlign="center">
                  {wk.week}
                </Typography>
              </Box>
            );
          }
        })}
      </Box>
      <Box
        onClick={() => {
          props?.setWeekRange({
            from: props?.weekRange.from + 1,
            to: props?.weekRange.to + 1
          });
        }}
        className="weeks-tab-next-btn"
      >
        <KeyboardArrowRightIcon />
      </Box>
    </Box>
  );
});

export default WeeksTab;
